module.exports = __webpack_public_path__ + "static/media/SMO.13b732c2.jpg";